<template>
    <div>

        <rkm-area
            v-if="form && paciente.nome"
            title="Paciente"
            type="fieldset"
            no-margin-top
        >

            <rkm-row>

                <rkm-col class="flex-grow-1">

                    <rkm-row>

                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}
                                <strong v-if="paciente.prefereNomeSocial">
                                    ({{ paciente.nomeSocial }})
                                </strong>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>

                        <rkm-col cols="3">

                            <p>
                                <strong>Data de nascimento:</strong>
                                <template v-if="paciente.dataNascimento">
                                    {{ paciente.dataNascimento }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Médico:</strong>
                                {{ form.medico }}
                            </p>

                            <p>
                                <strong>Uso de Medicamentos:</strong>
                                {{ form.usoMedicamento }}
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">

                            <p>
                                <strong>Idade:</strong>
                                <template v-if="paciente.idade">
                                    {{ paciente.idade }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>

                            <p>
                                <strong>Data do agendamento:</strong>
                                <template>
                                    {{ form.dataAgendamento }}
                                </template>
                            </p>

                            <p>
                                <strong>Suspeita Clínica:</strong>
                                {{ form.suspeitaClinica }}
                            </p>
                        </rkm-col>

                        <rkm-col>

                            <p>
                                <strong>Sexo:</strong>
                                <template>
                                    {{ paciente.sexo }}
                                </template>
                            </p>

                            <p>
                                <strong>Data da coleta:</strong>
                                <template>
                                   {{ form.dataColeta }}
                                </template>
                            </p>

                            <p>
                                <strong>Observações:</strong>
                                {{ form.observacao }}
                            </p>
                        </rkm-col>

                        <rkm-col>

                            <p v-if="paciente.telefone">
                                <strong>Telefone:</strong>
                                {{ paciente.telefone | formatPhoneOrCellPhone }}
                            </p>

                            <p>
                                <strong>Realização do exame:</strong>
                                <template>
                                    {{ form.dataAtual }}
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="!exames"
            :title="model.exameNome"
            no-margin-top
            class="pb-0 mb-0"
        >

            <rkm-tabs>

                <rkm-tab
                    title="RESULTADO"
                    :disabled="model.naoRealizado || model.novaColeta ? true : false"
                >

                    <rkm-row class="table-th">

                        <rkm-col cols="3">Descrição</rkm-col>
                        <rkm-col>Valor encontrado</rkm-col>
                        <rkm-col>Unidade</rkm-col>
                        <rkm-col>Referência</rkm-col>
                        <rkm-col>Situação</rkm-col>
                    </rkm-row>

                    <rkm-row
                        v-for="(item, index) in itemsNotSave.filter(info => info.valorAbsoluto === null || info.valorAbsoluto === false)"
                        :key="index"
                        :class="item.situacao == 'Alterado' ? 'table-td-alterado' : 'table-td'"
                    >

                        <rkm-col v-if="item.referenciaEspecial" cols="12">
                            <div class="html" v-html="item.referenciaEspecial"></div>
                        </rkm-col>

                        <rkm-col v-else cols="3">
                            {{ item.descricao }}
                        </rkm-col>

                        <rkm-col
                            v-if="item.tipoResultadoId == enums.tipoResultado.CAIXA_TEXTO"
                            cols="9"
                            class="pt-1 pb-1"
                        >
                            <rkm-form-textarea
                                v-model="item.resultado"
                                rows="1"
                            >
                            </rkm-form-textarea>
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                            && item.casaDecimalId == enums.casaDecimal.NENHUMA"
                        >
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model="item.resultado"
                                class="pt-1 mb-0"
                                number
                                :handleKeyDown="handleSituacao(item)"
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                            && item.casaDecimalId == enums.casaDecimal.UMA"
                        >
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model="item.resultado"
                                class="pt-1 mb-0"
                                v-money="moneyPrecisionOne"
                                :handleKeyDown="handleSituacao(item)"
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                            && item.casaDecimalId == enums.casaDecimal.DUAS"
                        >
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model="item.resultado"
                                class="pt-1 mb-0"
                                v-money="moneyPrecisionTwo"
                                :handleKeyDown="handleSituacao(item)"
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                            && item.casaDecimalId == enums.casaDecimal.TRES"
                        >
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model="item.resultado"
                                class="pt-1 mb-0"
                                v-money="moneyPrecisionThree"
                                :handleKeyDown="handleSituacao(item)"
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                            && item.casaDecimalId == enums.casaDecimal.QUATRO"
                        >
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model="item.resultado"
                                class="pt-1 mb-0"
                                v-money="moneyPrecisionFour"
                                :handleKeyDown="handleSituacao(item)"
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.TEXTO">
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model.trim="item.resultado"
                                class="pt-1 mb-0"
                                alpha-space
                                small
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.TEXTOENUMERO">
                            <rkm-form-input
                                v-show="item.visivel"
                                v-model.trim="item.resultado"
                                class="pt-1 mb-0"
                                small
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.LISTA">
                            <rkm-form-select
                                text-field="descricao"
                                value-field="id"
                                class="pt-1 mb-0"
                                v-model="item.resultado"
                                :options="item.lista"
                                show-default-option
                                @change="handleSituacaoLista(item)"
                            />
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.FORMULA">
                           {{ handleFormula(item).toString().replace('-', '') }}
                        </rkm-col>

                        <rkm-col v-else></rkm-col>

                        <rkm-col v-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO && !item.referenciaEspecial
                            && item.variavel.length > 0 && !item.unidadeId">
                            {{ handleValorAbsoluto(item) }}
                        </rkm-col>

                        <rkm-col v-else-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO && !item.referenciaEspecial">
                            {{ item.unidade }}
                        </rkm-col>

                        <rkm-col v-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO && !item.referenciaEspecial">
                            {{ item.referencia }}
                        </rkm-col>

                        <rkm-col v-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO && !item.referenciaEspecial">
                            {{ item.situacao }}
                        </rkm-col>
                    </rkm-row>
                </rkm-tab>

                <rkm-tab
                    title="NÃO REALIZADO / NOVA COLETA"
                >

                    <rkm-row>
                        <rkm-col cols="3" class="pt-2">
                            <rkm-form-checkbox
                                v-model="model.naoRealizado"
                                @change="handleNaoRealizado"
                                inline
                            >
                                Não realizado
                            </rkm-form-checkbox>

                            <rkm-form-checkbox
                                v-model="model.novaColeta"
                                @change="handleNovaColeta"
                                inline
                            >
                                Nova coleta
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto" class="pt-2">
                            Motivo
                        </rkm-col>

                        <rkm-col cols="2">

                            <rkm-form-select
                                :options="form.motivo"
                                show-default-option
                                text-field="descricao"
                                v-model="model.motivoId"
                                value-field="id"
                                cols="2"
                                class="mb-0"
                                :disabled="!model.novaColeta && !model.naoRealizado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-tab>

                <rkm-row class="table-td pt-1 mt-2">

                    <rkm-col cols="3">
                        Observação
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-textarea
                            v-model="model.observacao"
                            rows="1"
                        >
                        </rkm-form-textarea>
                    </rkm-col>
                </rkm-row>
            </rkm-tabs>
        </rkm-area>

        <template v-if="exames">
            <rkm-area
                v-for="(itemExame, index) in model.exames"
                :key="index"
                :title="itemExame.exameNome"
                no-margin-top
                class="pb-0 mb-0"
            >

                <rkm-tabs :key="index">

                    <rkm-tab
                        title="RESULTADO"
                        :disabled="itemExame.naoRealizado || itemExame.novaColeta ? true : false"
                    >

                        <rkm-row class="table-th">

                            <rkm-col cols="3">Descrição</rkm-col>
                            <rkm-col>Valor encontrado</rkm-col>
                            <rkm-col>Unidade</rkm-col>
                            <rkm-col>Referência</rkm-col>
                            <rkm-col>Situação</rkm-col>
                        </rkm-row>

                        <rkm-row
                            v-for="(item, index) in itemExame.composicao.filter(info => info.valorAbsoluto === null || info.valorAbsoluto === false)"
                            :key="index"
                            :class="item.situacao == 'Alterado' ? 'table-td-alterado' : 'table-td'"
                        >
                            <rkm-col v-if="item.referenciaEspecial" cols="12">

                                <div class="html" v-html="item.referenciaEspecial"></div>
                            </rkm-col>

                            <rkm-col v-else cols="3">
                                {{ item.descricao }}
                            </rkm-col>

                            <rkm-col v-if="item.tipoResultadoId == enums.tipoResultado.CAIXA_TEXTO" cols="9" class="pt-1 pb-1">
                                <rkm-form-textarea
                                    v-model="item.resultado"
                                    rows="1"
                                >
                                </rkm-form-textarea>
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                                && item.casaDecimalId == enums.casaDecimal.NENHUMA"
                            >
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model="item.resultado"
                                    class="pt-1 mb-0"
                                    number
                                    :handleKeyDown="handleSituacao(item)"
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                                && item.casaDecimalId == enums.casaDecimal.UMA"
                            >
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model="item.resultado"
                                    class="pt-1 mb-0"
                                    v-money="moneyPrecisionOne"
                                    :handleKeyDown="handleSituacao(item)"
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                                && item.casaDecimalId == enums.casaDecimal.DUAS"
                            >
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model="item.resultado"
                                    class="pt-1 mb-0"
                                    v-money="moneyPrecisionTwo"
                                    :handleKeyDown="handleSituacao(item)"
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                                && item.casaDecimalId == enums.casaDecimal.TRES"
                            >
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model="item.resultado"
                                    class="pt-1 mb-0"
                                    v-money="moneyPrecisionThree"
                                    :handleKeyDown="handleSituacao(item)"
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.NUMERICO
                                && item.casaDecimalId == enums.casaDecimal.QUATRO"
                            >
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model="item.resultado"
                                    class="pt-1 mb-0"
                                    v-money="moneyPrecisionFour"
                                    :handleKeyDown="handleSituacao(item)"
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.TEXTO">
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model.trim="item.resultado"
                                    class="pt-1 mb-0"
                                    alpha-space
                                    small
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.TEXTOENUMERO">
                                <rkm-form-input
                                    v-show="item.visivel"
                                    v-model.trim="item.resultado"
                                    class="pt-1 mb-0"
                                    small
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.LISTA">
                                <rkm-form-select
                                    text-field="descricao"
                                    value-field="id"
                                    class="pt-1 mb-0"
                                    v-model="item.resultado"
                                    :options="item.lista"
                                    show-default-option
                                    @change="handleSituacaoLista(item)"
                                />
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId == enums.tipoResultado.FORMULA">
                                {{ handleFormula(item).toString().replace('-', '') }}
                            </rkm-col>

                            <rkm-col v-else></rkm-col>

                            <rkm-col v-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO
                                && !item.referenciaEspecial && item.variavel.length > 0 && !item.unidadeId">
                                    {{ handleValorAbsoluto(item) }}
                            </rkm-col>

                            <rkm-col v-else-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO
                                && !item.referenciaEspecial">
                                    {{ item.unidade }}
                            </rkm-col>

                            <rkm-col v-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO
                                && !item.referenciaEspecial">
                                    {{ item.referencia }}
                            </rkm-col>

                            <rkm-col v-if="item.tipoResultadoId != enums.tipoResultado.CAIXA_TEXTO
                                && !item.referenciaEspecial">
                                    {{ item.situacao }}
                            </rkm-col>
                        </rkm-row>
                    </rkm-tab>

                    <rkm-tab
                        title="NÃO REALIZADO / NOVA COLETA"
                    >

                        <rkm-row>

                            <rkm-col cols="3" class="pt-2">
                                <rkm-form-checkbox
                                    v-model="itemExame.naoRealizado"
                                    @change="handleNaoRealizadoExame(itemExame)"
                                    inline
                                >
                                    Não realizado
                                </rkm-form-checkbox>

                                <rkm-form-checkbox
                                    v-model="itemExame.novaColeta"
                                    @change="handleNovaColetaExame(itemExame)"
                                    inline
                                >
                                    Nova coleta
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto" class="pt-2">
                                Motivo
                            </rkm-col>

                            <rkm-col cols="2">

                                <rkm-form-select
                                    :options="form.motivo"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="itemExame.motivoId"
                                    value-field="id"
                                    cols="2"
                                    class="mb-0"
                                    :disabled="!itemExame.novaColeta && !itemExame.naoRealizado"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-tab>

                    <rkm-row class="table-td pt-1 mt-2">

                        <rkm-col cols="3">
                            Observação
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-textarea v-model="itemExame.observacao" rows="1"></rkm-form-textarea>
                        </rkm-col>
                    </rkm-row>
                </rkm-tabs>
            </rkm-area>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Filters.
import format from '@/filters/formats'

//Directives
import { VMoney } from 'v-money'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import tipoResultado from '@/enums/parametrizacao/composicaoTipoResultado'
import casaDecimal from '@/enums/parametrizacao/composicaoCasaDecimal'
import tipoFator from '@/enums/exame-laboratorial/tipoFator'
import tipoOperacao from '@/enums/exame-laboratorial/tipoOperacao'

export default {
    directives: { money: VMoney },
    computed: {
        fields() {
            const fields = [

                {
                    key: "descricao",
                    label: "Descrição",
                    class: 'table-td',
                },
                {
                    key: "valorEncontrado",
                    label: "Valor encontrado",
                    class: 'table-td',
                },

                {
                    key: "unidade",
                    label: "Unidade",
                    class: 'col-min table-td',
                },
                {
                    key: "referencia",
                    label: "Referência",
                    class: 'table-td',
                },
                {
                    key: "situacao",
                    label: "Situação",
                    class: 'table-td',
                },
            ]

            return fields
        },
        itemsNotSave() {

            return this.model.composicao ?? []
        }
    },
    created() {

        this.repositories = {
            lancamento: this.getConectaSusRepository('exameLaboratorial.lancamentoResultado'),
        },

        this.load();
    },
    filters: {
        ...format,
    },
    data() {
        return {
            form: {},
            model: {
                exame: null,
                exameId: null,
                exameNome: '',
                pacienteId: null,
                motivoId: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            exames: false,
            observacao: null,
            saveAgendamento: {
                agendamentos: [],
            },
            agendamentoExame: [],
            items: [],
            enums: {
                statusAgendamento,
                preferenciaNome,
                tipoResultado,
                casaDecimal,
                tipoFator,
                tipoOperacao
            },
            paciente: {
                id: null,
                nome: null,
                preferenciaNomeId: null,
                nomeSocial: '',
                prontuario: null,
                cpf: null,
                cns: null,
                telefone: null,
                dataNascimento: null,
                idade: null,
                anos: null,
                meses: null,
                dias: null,
                sexo: null,
                sexoId: null,
                sexoDescricao: '',
                nomeMae: '',
                unidadeReferencia: '',
            },
            moneyPrecisionOne: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 1,
                masked: false
            },
            moneyPrecisionTwo: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            moneyPrecisionThree: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 3,
                masked: false
            },
            moneyPrecisionFour: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 4,
                masked: false
            },
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id == null) {

                this.$emit('save')
            } else {

                this.setLoading()

                this.repositories.lancamento.show(this.id)
                    .then(({ data }) => {

                        this.form = data.form
                        this.model = data.model
                        this.feriado = data.form.feriados

                        this.loadPaciente(data.form.paciente)
                        this.handleExames(data.model.exames)
                        this.handlePrint()
                        this.handleHistorico()

                        this.dataColeta = data.form.dataColeta
                        this.dataAgendamento = data.form.dataAgendamento

                        this.$nextTick().then(() => {

                            this.tabRefs = [
                                this.$refs.TabExamesAgendados,
                                this.$refs.TabAgendarExames,
                            ]
                        })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleExames(exames) {

            if (exames && exames.length > 1) {

                    let nomeExames = ''

                    exames.forEach(exameNomeIncluido => {

                        if(!nomeExames){

                            nomeExames = exameNomeIncluido.exameNome
                        } else {

                            nomeExames = nomeExames + ', ' + exameNomeIncluido.exameNome
                        }
                    })

                    const confirm = async () => {

                        this.$emit('agrupado', true)

                        this.exames = true

                        this.handlePrint()
                        this.handleHistorico()

                        return false
                    }

                    const msg = `Deseja lançar os exames (${nomeExames}) por grupo de exame?`

                    this.showConfirmation(msg, confirm)

                    return false
            }
        },
        handlePrint() {

            if (this.exames) {

                if (this.model.exames.find(u => u.naoRealizado !== true && u.novaColeta !== true)) {

                    this.$emit('handleShowButton', true)
                } else {

                    this.$emit('handleShowButton', false)
                }
            } else {

                if (this.model.naoRealizado !== true && this.model.novaColeta !== true) {

                    this.$emit('handleShowButton', true)
                } else {

                    this.$emit('handleShowButton', false)
                }
            }
        },
        handleHistorico() {

            if (this.exames) {

                const historicos = []

                this.model.exames.forEach(item => {

                    item.historico.forEach(historico => {

                        historicos.push(historico)
                    })
                })

                this.$emit('handleHistorico', historicos)
            } else {

                this.$emit('handleHistorico', this.model.historico)
            }
        },
        loadPaciente(paciente) {

            this.paciente.nome = paciente.nome
            this.paciente.prefereNomeSocial = paciente.prefereNomeSocial
            this.paciente.nomeSocial = paciente.nomeSocial
            this.paciente.telefone = paciente.telefone
            this.paciente.dataNascimento = paciente.dataNascimento
            this.paciente.idade = paciente.idade
            this.paciente.sexo = paciente.sexo.descricao
        },
        save(){

            this.setLoading()

            this.repositories.lancamento.store(this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        savePrint(){

            this.setLoading()

            this.repositories.lancamento.store(this.prepareData())
                .then(() => {

                    this.$emit('print')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        printResultadoAgrupado(){

            this.setLoading()

            this.repositories.lancamento.store(this.prepareData())
                .then(() => {

                    this.$emit('printResultadoAgrupado')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {


            if (this.exames) {

                this.saveAgendamento.agendamentos = this.clone(this.model.exames)
            } else {

                this.saveAgendamento.agendamentos.push(this.clone(this.model))
            }

            const notSave = this.saveAgendamento

            return this.camelObjectKeysToSnakeRecursive(notSave)
        },
        handleNovaColeta() {

            this.model.naoRealizado = null

            if (!this.model.naoRealizado && !this.model.novaColeta) {

                this.model.motivoId = null
            }

            this.handlePrint()
        },
        handleNaoRealizado() {

            this.model.novaColeta = null

            if (!this.model.naoRealizado && !this.novaColeta) {

                this.model.motivoId = null
            }

            this.handlePrint()
        },
        handleNovaColetaExame(item) {

            item.naoRealizado = null

            if (!item.naoRealizado && !item.novaColeta) {

                item.motivoId = null
            }

            this.handlePrint()
        },
        handleNaoRealizadoExame(item) {

            item.novaColeta = null

            if (!item.naoRealizado && !item.novaColeta) {

                item.motivoId = null
            }

            this.handlePrint()
        },
        handleSituacao(item) {

            if (item.resultado && (parseFloat(item.limiteInferior.replace('.','').replace(',','.')) > 0
                || parseFloat(item.limiteSuperior.replace('.','').replace(',','.')) > 0)) {

                    if (parseFloat(item.resultado.replace('.','').replace(',','.'))
                        >= parseFloat(item.limiteInferior.replace('.','').replace(',','.'))
                        && parseFloat(item.resultado.replace('.','').replace(',','.'))
                        <= parseFloat(item.limiteSuperior.replace('.','').replace(',','.'))
                    ) {

                        item.situacao = 'Normal'
                    } else {

                        item.situacao = 'Alterado'
                    }
            } else {

                item.situacao = null
            }
        },
        handleSituacaoLista(item) {

            if (item.resultado) {

                item.situacao = item.lista.find(u => u.id === item.resultado).situacao
            } else {

                item.situacao = null
            }
        },
        handleValorAbsoluto(item) {

            let valorAbsoluto = null

            if (this.exames) {

                item.variavel.forEach(variavel => {

                    this.model.exames.forEach(exame => {

                        exame.composicao.filter(formula => formula.tipoResultadoId == this.enums.tipoResultado.FORMULA
                            &&  formula.valorAbsoluto == true)
                                .map(itemComposicao => {

                                    if (itemComposicao.variavel.find(composicaoVariavel => composicaoVariavel.fatorId == variavel.fatorId)) {

                                        valorAbsoluto = this.handleFormula(itemComposicao)
                                    }
                                })
                    })
                })
            } else {

                item.variavel.forEach(variavel => {

                    this.model.composicao.filter(formula => formula.tipoResultadoId == this.enums.tipoResultado.FORMULA
                        && formula.valorAbsoluto == true)
                            .map(itemComposicao => {

                                if (itemComposicao.variavel.find(composicaoVariavel => composicaoVariavel.fatorId == variavel.fatorId)) {

                                    valorAbsoluto = this.handleFormula(itemComposicao)
                                }
                            })
                })
            }

            return valorAbsoluto;
        },
        handleFormula(item) {

            let valor = 0

            item.formula.map(formula => {


                formula.fatores.forEach(fator => {

                    if (fator.tipo == this.enums.tipoFator.CONSTANTE) {

                        if (fator.operacaoId == this.enums.tipoOperacao.SOMA) {

                            valor = valor + fator.valor.replace('.','').replace(',','.')
                        } else if (fator.operacaoId == this.enums.tipoOperacao.SUBTRACAO) {

                            valor = valor - fator.valor.replace('.','').replace(',','.')
                        } else if (fator.operacaoId == this.enums.tipoOperacao.DIVISAO) {

                            valor = valor / fator.valor.replace('.','').replace(',','.')
                        } else if (fator.operacaoId == this.enums.tipoOperacao.MULTIPLICACAO) {

                            valor = valor * fator.valor.replace('.','').replace(',','.')
                        } else if (fator.operacaoId == this.enums.tipoOperacao.MODULO) {

                            valor = valor % fator.valor.replace('.','').replace(',','.')
                        } else if (fator.operacaoId == this.enums.tipoOperacao.EXPONENCIACAO) {

                            valor = valor ** fator.valor.replace('.','').replace(',','.')
                        }
                    } else {

                        if (this.exames) {

                            this.model.exames.forEach(exame => {

                                exame.composicao.filter(composicao => composicao.valorAbsoluto == null || composicao.valorAbsoluto === false).map(itemVariavel => {

                                    let variavel = itemVariavel.variavel.find(variavel => variavel.fatorId == fator.id)

                                    if (variavel) {

                                        let valorResultado = 0
                                        let resultado = itemVariavel.resultado

                                        if(typeof resultado == "string") {
                                            resultado = parseFloat(itemVariavel.resultado.replace('.','').replace(',','.'))
                                        }

                                        if (fator.exponenciacao) {

                                            if (fator.exponenciacaoTipo == this.enums.tipoFator.CONSTANTE) {

                                                valorResultado = resultado
                                                    ** parseFloat(fator.exponenciacaoValor.replace('.','').replace(',','.'))

                                            } else {

                                                valorResultado = resultado ** resultado
                                            }
                                        } else {

                                            valorResultado = resultado
                                        }

                                        if (fator.operacaoId == this.enums.tipoOperacao.SOMA
                                            && itemVariavel.resultado !== null) {

                                                valor = valor + valorResultado
                                        } else if (fator.operacaoId == this.enums.tipoOperacao.SUBTRACAO
                                            && itemVariavel.resultado !== null) {

                                                valor = valor - valorResultado
                                        } else if (fator.operacaoId == this.enums.tipoOperacao.DIVISAO
                                            && itemVariavel.resultado !== null) {

                                                valor = valor / valorResultado
                                        } else if (fator.operacaoId == this.enums.tipoOperacao.MULTIPLICACAO
                                            && itemVariavel.resultado !== null) {

                                                valor = valor * valorResultado
                                        } else if (fator.operacaoId == this.enums.tipoOperacao.MODULO
                                            && itemVariavel.resultado !== null) {

                                                valor = valor % valorResultado
                                        } else if (fator.operacaoId == this.enums.tipoOperacao.EXPONENCIACAO
                                            && itemVariavel.resultado !== null) {

                                                valor = valor ** valorResultado
                                        }
                                    }
                                })
                            })

                        } else {

                            this.itemsNotSave.filter(composicao => composicao.valorAbsoluto == null || composicao.valorAbsoluto === false).map(itemVariavel => {

                                let variavel = itemVariavel.variavel.find(variavel => variavel.fatorId == fator.id)

                                if (variavel) {

                                    let valorResultado = 0
                                    let resultado = itemVariavel.resultado

                                    if(typeof resultado == "string") {
                                        resultado = parseFloat(resultado.replace('.','').replace(',','.'))
                                    }

                                    if (fator.exponenciacao) {

                                        if (fator.exponenciacaoTipo == this.enums.tipoFator.CONSTANTE) {

                                            valorResultado = resultado
                                                ** parseFloat(fator.exponenciacaoValor.replace('.','').replace(',','.'))

                                        } else {

                                            valorResultado = resultado ** resultado
                                        }
                                    } else {

                                        valorResultado = resultado
                                    }

                                    if (fator.operacaoId == this.enums.tipoOperacao.SOMA && resultado !== null) {

                                        valor = valor + valorResultado
                                    } else if (fator.operacaoId == this.enums.tipoOperacao.SUBTRACAO && resultado !== null) {

                                        valor = valor - valorResultado
                                    } else if (fator.operacaoId == this.enums.tipoOperacao.DIVISAO && resultado !== null) {

                                        valor = valor / valorResultado
                                    } else if (fator.operacaoId == this.enums.tipoOperacao.MULTIPLICACAO && resultado !== null) {

                                        valor = valor * valorResultado
                                    } else if (fator.operacaoId == this.enums.tipoOperacao.MODULO && resultado !== null) {

                                        valor = valor % valorResultado
                                    } else if (fator.operacaoId == this.enums.tipoOperacao.EXPONENCIACAO && resultado !== null) {

                                        valor = valor ** valorResultado
                                    }
                                }
                            })
                        }
                    }
                })
            })

            if (valor) {

                if (item.casaDecimalId == this.enums.casaDecimal.UMA) {

                    valor = valor.toFixed(1).replace('.',',')
                } else if (item.casaDecimalId == this.enums.casaDecimal.DUAS) {

                    valor = valor.toFixed(2).replace('.',',')
                } else if (item.casaDecimalId == this.enums.casaDecimal.TRES) {

                    valor = valor.toFixed(3).replace('.',',')
                } else if (item.casaDecimalId == this.enums.casaDecimal.QUATRO) {

                    valor = valor.toFixed(4).replace('.',',')
                }
            } else {

                if (isNaN(valor)) {
                    valor = 0
                }
            }

            item.resultado = valor

            return valor
        }
    },
    props: {
        id: { type: Number }
    },
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
    vertical-align: middle;
    color: var(--gray-dark);
}
.table-td {
    background: #fff;
    padding: 0 10px;
    line-height: 40px;
    min-height: 40px;
    border-top: 1px solid #dee2e6;
    vertical-align: middle;
}
.table-td-alterado {
    background:  #dc354515;
    padding: 0 10px;
    line-height: 40px;
    min-height: 40px;
    border-top: 1px solid #dee2e6;
    vertical-align: middle;
}

.max-h input {
    max-height: 25px!important;
}

p {
    margin: 0!important;
}

.html {
    margin: 5px 0!important;
    line-height: normal!important;
}
.html >>> p {
    margin-bottom: 0!important;
}
</style>